/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChartPeriodDto {
    M1 = 'M1',
    M5 = 'M5',
    M15 = 'M15',
    M30 = 'M30',
    H1 = 'H1',
    H4 = 'H4',
    D1 = 'D1',
    W1 = 'W1',
    MN1 = 'Mn1',
}
